import React, { Fragment } from 'react';
import {
  string,
  arrayOf,
  shape,
  func,
} from 'prop-types';
import { Query } from 'react-apollo';
import Layout from 'components/layout';
import withApplicationConfig from 'containers/withApplicationConfig';
import ContactInfo from 'components/staticPage/ContactInfo/ContactInfo';
import Introduction from 'components/staticPage/Introduction/Introduction';
import Queries from 'queries';
import TestimonialsPanel from 'components/staticPage/Testimonials/TestimonialsPanel';
import MissionStatement from 'components/staticPage/Banners/MissionStatement';
import BusinessModelPanel from 'components/staticPage/BusinessModelPanel/BusinessModelPanel';
import NewsLetterPanel, { staticTextKeys as newletterPanelStaticTextKeys } from 'components/staticPage/NewsLetter/NewsLetterPanel';
import {
  getAuthQueryVariables, getStaticText, getImages,
} from 'helpers/Utils';
import {
  contentGroupingsTrack,
  withTracking,
} from '../../components/tracking';
import StaticPageTemplate from './StaticPageTemplate';
import SocialMedia from './SocialMedia';

const StaticPage = ({
  pages,
  imageDimensions,
  route,
  introduction,
  label,
  links,
  newsletterSubscription,
  contactInfo,
  localisation,
  language,
  contentstackKeys,
  track,
}) => {
  const pageProps = pages.filter(page => page.route === route).shift();
  contentGroupingsTrack(track, 'static');
  return (
    <Query
      query={Queries.GetStaticPage}
      variables={{
        language: localisation[language],
        richTextBlockKeys: [pageProps.route],
        product: pageProps.route,
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: newletterPanelStaticTextKeys,
        }),
      }}
    >
      {({ loading, data, refetch }) => {
        const staticText = getStaticText(data);
        return (
          <Layout
            {...data.pageConfig}
            componentConfig={data?.componentConfig}
            seoMetadata={data.seoMetadata}
            customerProfile={data?.customerProfile}
            staticText={staticText}
            images={getImages(data)}
            refetch={refetch}
          >
            {loading
              || (
                <Fragment>
                  <StaticPageTemplate {...pageProps} richTextBlocks={data.richTextBlock || []}>
                    <ContactInfo key="contactInfo" {...contactInfo} />
                    <Introduction key="introduction" {...introduction} />
                    <SocialMedia key="socialMedia" label={label} links={links} />

                  </StaticPageTemplate>
                  {data?.homePage?.missionStatement
                    && <MissionStatement {...data?.homePage?.missionStatement} />
                  }
                  {data?.homePage?.testimonialsList
                    && getTestimonialsPanel(data?.homePage?.testimonialsList)
                  }
                  {data?.homePage?.benefits
                    && (
                    <BusinessModelPanel
                      {...data?.homePage?.benefits}
                      imageDimensions={imageDimensions}
                    />
                    )
                  }
                  {data?.homePage?.subscribe && (
                    <NewsLetterPanel
                      key="newsletter"
                      language={localisation[language]}
                      {...newsletterSubscription}
                      {...data.homePage.subscribe}
                      staticText={staticText}
                      page="static"
                    />
                  )}
                </Fragment>
              )}
          </Layout>
        );
      }
      }
    </Query>
  );
};

function getTestimonialsPanel(
    testimonialsArray
) {
  return testimonialsArray?.filter((testimonial) => {
    return testimonial !== null && typeof testimonial !== undefined;
  }).map((testimonial, i) => (
      <TestimonialsPanel
          key={`testimonialspanel-${i}`}
          heading={testimonial.heading}
          testimonial={testimonial.testimonial}
      />
  ));
}

StaticPage.propTypes = {
  pages: arrayOf(shape({})),
  route: string.isRequired,
  imageDimensions: shape({}).isRequired,
  match: shape({}).isRequired,
  location: shape({}).isRequired,
  localisation: shape({}).isRequired,
  language: string.isRequired,
  contactInfo: shape({
    officeHours: string,
    tel: string,
    content: string,
    address: string,
  }),
  introduction: shape({}),
  label: string,
  newsletterSubscription: shape({}),
  links: arrayOf(shape({})),
  contentstackKeys: shape({}).isRequired,
  track: func.isRequired,
};

StaticPage.defaultProps = {
  pages: null,
  contactInfo: null,
  introduction: null,
  label: null,
  newsletterSubscription: null,
  links: [{}],
};

export default withTracking(withApplicationConfig(StaticPage, ['languages', 'aboutUs', 'socialMedia', 'frontPage', 'contentstackKeys']));
